/* Binder 'Giv mig besked' på udsolgte / coming soon-produktkort (snippets/product-card-grid.liquid).
   Delegeret handler; indlæses én gang i layout/theme.liquid når binders er slået til. */
(function(){
  if(window.__mtwCardBinderInit) return;
  window.__mtwCardBinderInit = true;

  function added(btn){
    btn.classList.add('is-added');
    var l = btn.querySelector('.mtw-act-label'); if(l) l.textContent = 'Du får besked ✓';
    btn.setAttribute('aria-label', 'Tilføjet til ønskelisten. Du får besked om ' + (btn.dataset.title || 'kortet'));
  }
  function guestForm(btn){
    var acts = btn.closest('.mtw-acts');
    if(!acts || acts.querySelector('.mtw-card-guest')) return;
    btn.style.display = 'none';
    acts.classList.add('is-guest');
    var f = document.createElement('form');
    f.className = 'mtw-card-guest';
    f.innerHTML = '<input type="email" class="mtw-card-email" placeholder="Din email" autocomplete="email" required><button type="submit" class="mtw-card-email-btn" aria-label="Få besked">→</button>';
    acts.appendChild(f);
    var inp = f.querySelector('input'); inp.focus();
    f.addEventListener('submit', function(e){
      e.preventDefault();
      var email = (inp.value||'').trim(); if(!email) return;
      var s = f.querySelector('button'); s.disabled = true;
      fetch(btn.dataset.proxy || '/apps/binders', {method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({ action:'subscribe', productGid:btn.dataset.pgid, email:email, title:btn.dataset.title, handle:btn.dataset.handle })})
        .then(function(r){ return r.json(); }).then(function(res){
          s.disabled = false;
          if(res && res.ok){ f.innerHTML = '<span class="mtw-card-done">Du får besked ✓</span>'; }
          else { inp.style.borderColor = '#c0392b'; }
        }).catch(function(){ s.disabled = false; });
    });
  }

  document.addEventListener('click', function(e){
    var btn = e.target.closest && e.target.closest('.mtw-card-binder');
    if(!btn) return;
    e.preventDefault();
    if(btn.classList.contains('is-added')) return;
    if(btn.dataset.loggedIn !== '1'){ guestForm(btn); return; }
    btn.disabled = true;
    fetch(btn.dataset.proxy || '/apps/binders', {
      method:'POST', headers:{'Content-Type':'application/json'},
      body: JSON.stringify({ action:'add', productGid:btn.dataset.pgid, title:btn.dataset.title, handle:btn.dataset.handle, image:btn.dataset.image, available:false })
    }).then(function(r){ return r.json(); }).then(function(res){
      btn.disabled = false;
      if(res && res.ok){ added(btn); }
    }).catch(function(){ btn.disabled = false; });
  });
})();
